import { INSTANCE_SPECIAL_CHAT_TYPES } from "services/types";
import { init, success, finish, error, updateOnly } from "services/common";
import { InstanceSpecialChatServices } from "./api";
import { message } from "antd";

const instanceSpecialChatServices = new InstanceSpecialChatServices();

export const addOrDeleteParticipantInQuickGroupChatUpdate = (id, body) => {
  return async (dispatch) => {
    dispatch(init(INSTANCE_SPECIAL_CHAT_TYPES.INSTANCE_SPECIAL_MESSAGE_CHAT));
    const response =
      await instanceSpecialChatServices.addOrDeleteParticipantInQuickGroupChatUpdate(
        id,
        body
      );
    dispatch(finish(INSTANCE_SPECIAL_CHAT_TYPES.INSTANCE_SPECIAL_MESSAGE_CHAT));
    if (response.isSuccess) {
      dispatch(
        success(
          INSTANCE_SPECIAL_CHAT_TYPES.INSTANCE_SPECIAL_MESSAGE_CHAT,
          response.data
        )
      );
    } else if (!response.isSuccess) {
      dispatch(error(response.errorMessage));
    }
  };
};
